<template>
    <console-content max-width="1280">
        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="tit tit--lg">교환 가능 상품 목록</v-col>
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <v-btn class="mr-1" color="secondary" rounded @click="showSearch = !showSearch"> <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터 </v-btn>
            </v-col>
        </v-row>

        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mt-3 mx-1">
                <v-card-title class="tit tit--xs font-weight-bold">검색필터</v-card-title>
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" persistent-placeholder hide-details @input="filter.searchValue = null" />
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-text-field
                                v-model="filter.searchValue"
                                label="검색어"
                                persistent-placeholder
                                hide-details
                                :disabled="!filter.searchKey"
                                @keydown.enter="
                                    page = 1;
                                    search(true);
                                "
                            />
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.shows" label="노출여부" :items="showsItems" @input="search(true)" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="search"> <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색 </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>

        <v-row class="mt-6 px-1" align="end">
            <v-col cols="auto" class="py-0 subtitle-2">검색수 : {{ summary.totalCount.format() }}</v-col>
            <v-spacer />
            <!-- <v-col cols="auto" class="py-0">
                <v-btn color="white" class="green--text px-2 ml-1" @click="excel">
                    <v-icon class="mr-2">mdi-microsoft-excel</v-icon>엑셀다운로드
                </v-btn>
            </v-col> -->
        </v-row>

        <v-data-table :items="partners" :headers="partnersHeaders" v-bind="{ loading }" hide-default-footer disable-sort disable-pagination class="mt-3 mx-1 elevation-1">
            <template #[`item.index`]="{ item }">
                <partner-index-edit :value="item" v-on="{ update }">
                    {{ item.index }}
                </partner-index-edit>
            </template>
            <v-layout slot="item.image" slot-scope="{ item }" justify-center>
                <v-img :src="item.image" width="100" height="100" contain />
            </v-layout>
            <!-- <template #[`item.url`]="{ item }">
                <a :href="item.url" target="_self">{{ item.url }}</a>
            </template> -->
            <template #[`item.shows`]="{ item }">
                <v-switch v-model="item.shows" hide-details class="pa-0 ma-0 d-inline-block" color="red lighten-2" @change="update({ _id: item._id, shows: item.shows })" />
            </template>
            <v-layout slot="item.actions" slot-scope="{ item }" justify-center>
                <!-- <v-icon small class="mx-1" @click="edit(item)">mdi-pencil</v-icon> -->
                <partner-dialog :value="item" @update="init">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon small class="mx-1" v-on="on" v-bind="attrs">mdi-pencil</v-icon>
                    </template>
                </partner-dialog>

                <v-icon small class="mx-1" @click="remove(item)">mdi-delete</v-icon>
            </v-layout>
            <template slot="item.createdAt" slot-scope="{ item }">
                <span>{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
            </template>
        </v-data-table>

        <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)" />

        <partner-dialog @update="init">
            <template v-slot:activator="{ on, attrs }">
                <v-btn fab fixed bottom right color="accent" v-bind="attrs" v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
            </template>
        </partner-dialog>
    </console-content>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import ConsoleContent from "@/templates/console/ConsoleContent.vue";
import { mdiMicrosoftExcel } from "@mdi/js";
import PartnerDialog from "@/components/console/partner/partner-dialog.vue";
import PartnerIndexEdit from "@/components/console/partner/partner-index-edit.vue";

export default {
    components: {
        ConsoleContent,
        PartnerDialog,
        PartnerIndexEdit,
    },
    data() {
        return {
            mdiMicrosoftExcel,
            loading: false,
            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
                type: this.$route.query.type || null,
                shows: this.$route.query.shows || null,
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            summary: { totalCount: 0 },
            partners: [],
            partnersHeaders: [
                { text: "순서", value: "index", align: "center" /* width: 10 */ },
                { text: "제목", value: "subject", align: "center" /* width: 10 */ },
                { text: "이미지", value: "image", align: "center" /* width: 10 */ },
                { text: "URL", value: "url", align: "center", width: 10 },
                { text: "노출", value: "shows", align: "center" /* width: 10 */ },
                { text: "생성일자", value: "createdAt", align: "center" /* width: 10 */ },
                { text: "actions", value: "actions", align: "center" /* width: 10 */ },
            ],

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "제목", value: "subject" },
            ],

            showsItems: [
                { text: ":: 전체 ::", value: null },
                { text: "노출", value: true },
                { text: "미노출", value: false },
            ],

        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.search(false);
        },
        async search(routable = false) {
            if (routable) {
                this.$router.push({
                    query: { ...this.filter, page: this.page },
                });
            }

            let { summary, partners } = await api.console.common.partners.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: this.filter,
            });

            this.partners = partners.map((partner) => ({ ...partner, image: `${partner.image}?t=${new Date().getTime()}` }));
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        edit(partner) {
            this.$router.push(`/console/common/partners/${partner._id}`);
        },
        async update(item) {
            if (this.loading) return;
            this.loading = true;
            try {
                await api.console.common.partners.put(item);
                this.init();
            } catch (error) {
                console.error(error);
                this.init();
            } finally {
                this.loading = false;
            }
        },

        async remove(partner) {
            if (confirm("해당 로고를 삭제하시겠습니까?")) {
                await api.console.common.partners.delete(partner);
                alert("로고가 삭제되었습니다");
                this.init();
            }
        },
    },
};
</script>